import CONTENT_ITEMS from '../common/scripts/jokes_widget/content'
import JokeCarouselWidget from '../common/scripts/jokes_widget/jokes_moment'
import { handleTouchEvents } from '../utilities/touchEvent'
import { onInViewport } from '../../assets/common/scripts/utilities/DOM_events'

const getItems = async (language: string) => {
  return CONTENT_ITEMS[language] || CONTENT_ITEMS.en
}

const initMoment = async (language: string) => {
  if (document.documentElement.getAttribute('data-mp-app-theme') !== 'moment') {
    return
  }

  const blocks: HTMLElement[] = Array.from(
    document.querySelectorAll(`.block--reveal-widget__jokes-widget`)
  )

  for (const block of blocks) {
    const onBlockInView = async () => {
      const items = await getItems(language)

      new JokeCarouselWidget(block, items, 'jokes')
    }

    onInViewport(block, onBlockInView)
  }
}

const init = () => {
  const language = document.documentElement.lang
  // noinspection JSIgnoredPromiseFromCall
  initMoment(language)
  handleTouchEvents('[data-mp-block-type="jokes_widget_block"] .swiper')
}

// Dynamic content loading requires async.  Need to make sure experiments have finished loading first.
if (window.experimentsLoaded) {
  init()
} else {
  document.addEventListener('experiment:initialized', () => {
    init()
  })
}
